import Styled from './styled'
import MatchIncident from '../MatchIncident'
import Task from '../Task'
import { Space } from 'antd'

export default function ActionPlan({ defaultAmountOfReturn, reportHeaderId, disabled }) {
  return (
    <Styled>
      <Space size="middle" direction="vertical" style={{ width: '100%' }}>
        <MatchIncident
          defaultAmountOfReturn={defaultAmountOfReturn}
          reportHeaderId={reportHeaderId}
          disabled={disabled}
        />
        <Task taskReportHeaderId={reportHeaderId} disabled={disabled} />
      </Space>
    </Styled>
  )
}
